import axios from 'axios';
import { GET_GIFS, GET_GIFS_SEARCH, GIF_ERROR } from './types';

// Get gifs
export const getGifs = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/giphy');

    dispatch({
      type: GET_GIFS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GIF_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get gifs by search
export const getGifsSearch = (formData) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  try {
    const res = await axios.post('/api/giphy', formData, config);

    dispatch({
      type: GET_GIFS_SEARCH,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GIF_ERROR,
      payload: {
        msg: err.response.statusText,
        status: err.response.status,
      },
    });
  }
};
